import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { useEffect, useState } from "react";
import { Col, Row } from "@/utils/bootstrap";
import { useRanger } from "react-ranger";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

interface Props {
  filter: IFilter;
  state: any[];
  setState: (state: any[]) => void;
}

const PriceRager: React.FC<Props> = ({ filter, state, setState }) => {
  const { data } = useGetCompanyQuery();
  const { currency, getPriceString } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.
enable_currencies_converter ?? true,
  });
  const min = filter.configurations.min ?? 0 * currency.exchange_rate;
  const max = filter.configurations.max ?? 1 * currency.exchange_rate;
  const stepSize = (max - min) / 20;
  const [values, setValues] = useState([min, max]);

  const { getTrackProps, segments, handles } = useRanger({
    min: min,
    max: max,
    stepSize: stepSize,
    values,
    onChange: (values) => {
      if (min === max) return;
      setValues(values);
      setState(values.map((val) => val / currency.exchange_rate));
    },
    onDrag: (values) => {
      if (values[1] > values[0]) setValues(values);
    },
  });
  useEffect(() => {
    if (!state || state.length < 2) setValues([min, max]);
    else setValues([+state[0], +state[1]]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  return (
    <div className="price-range">
      <Row className="range">
        <Col className="p-0 col-auto">
          {`${getPriceString(min)} ${currency.symbol}`}
        </Col>
        <Col className="p-0 d-flex justify-content-end">
          {`${getPriceString(max)} ${currency.symbol}`}
        </Col>
      </Row>
      <div
        {...getTrackProps({
          style: {
            height: "3px",
            margin: "0 10px",
          },
        })}
      >
        {segments.map(({ getSegmentProps }, index) => (
          <div
            {...getSegmentProps({
              className: index === 1 ? "in-range" : "out-range",
            })}
            key={index}
          >
            {index > 0 && (
              <div style={{ marginTop: -8.5, marginInlineStart: -10 }}>
                <div
                  className={`handle justify-content-${
                    values[index - 1] < min + stepSize * 10
                      ? "start"
                      : values[index - 1] > max - stepSize * 10
                      ? "end"
                      : "center"
                  }`}
                >
                  <div className="handle-label text-nowrap">
                    {`${getPriceString(values[index - 1])} ${currency.symbol}`}
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
        {handles.map(({ getHandleProps }, key) => (
          <button
            {...getHandleProps({
              style: {
                width: 20,
                height: 20,
                appearance: "none",
                border: "none",
                outline: "none",
                background: "transparent",
              },
            })}
            key={key}
          />
        ))}
      </div>
      <br />
    </div>
  );
};

export default PriceRager;
